import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { EndPoints } from "../../Constants/endpoints";
import { useToast } from "../../Services/ToastContext";
import useAddPrescription from "../../api/Prescription/useAddPrescription";
 import { cleanFormData } from "./hooks/usePrescriptionSubmit";
import { PrescriptionBaseForm } from "./components";

const CreatePrescriptionTemplate: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showToast } = useToast();
  const queryClient = useQueryClient();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const location = useLocation();

  const handleBack = () => {
    navigate(location.state?.from || -1);
  }

  const { mutate, isPending } = useAddPrescription();

  const handleSubmit = (data: any) => {
    setIsSubmitting(true);
    const cleanedData = cleanFormData(data);

    mutate(cleanedData, {
      onSuccess: () => {
        showToast(t("prescription_added_successfully"), "success");
        queryClient.refetchQueries({
          queryKey: [EndPoints.GetPrescriptions],
          exact: false,
        });

        handleBack()
      },
      onError: (error: any) => {
        showToast(error.message || t("error_adding_prescription"), "error");
        setIsSubmitting(false);
      },
    });
  };




  return (
    <PrescriptionBaseForm
      onSubmit={handleSubmit}
      onDiscard={handleBack}
      config={{
        title: t("create_prescription_template"),
        submitButtonText: t("save"),
        caseLabel: t("template_name"),
        showPatientInfo: false,
        maxInstructionsLength: 250,
      }}
      isLoading={isPending || isSubmitting}
    />
  );
};

export default CreatePrescriptionTemplate;
